import { BillingAccountById } from "@/admin/accounts/BillingAccountBlock.tsx";
import { field, type FieldsOf } from "@/admin/FieldConfig.tsx";
import { BillingCycle } from "@/admin/metal/machine/BillingCycle.tsx";
import type { AdminMachineWithOs, ItemOsInfo } from "@/admin/metal/machine/machinesWithOs.ts";
import { OsViewer } from "@/admin/metal/machine/OsViewer.tsx";
import { StatusEditButton } from "@/admin/metal/machine/StatusEditButton.tsx";
import { whenNotNull } from "@/admin/table_fields/whenNotNull.tsx";
import { apiDatetimeToDate } from "@warrenio/api-spec/conversion";
import { pick } from "remeda";

export const machineItemFields = {
    uuid: field("UUID", (e) => e.uuid, { copyable: true, inTable: false }),

    label: field("Label", (e) => e.label),
    status: field("Status", (e) => e.status, { render: StatusEditButton }),
    spec_title: field("Spec", (e) => e.spec.title),
    os: field("OS", (e): ItemOsInfo => pick(e, ["os_type", "os"]), { render: OsViewer }),
    admin_notes: field("Notes", (e) => e.admin_notes, { editTitle: "Internal Notes" }),
    ip_public_v4: field("IPv4", (e) => e.ip_public_v4, { inTable: false }),
    ip_public_v6: field("IPv6", (e) => e.ip_public_v6, { inTable: false }),

    ssh_credentials: field("SSH creds", (e) => e.ssh_credentials, { inTable: false }),
    billing_account_id: field("Billing Account", (e) => e.billing_account_id, {
        render: whenNotNull(BillingAccountById),
    }),
    lease_name: field("Lease Name", (e) => e.lease?.display_name),

    billing_cycle: field("Billing cycle", (e) => e.period_hours, { render: BillingCycle }),

    end_of_cycle: field("End of cycle", (e) => e.ends_at),

    created_at: field("Created At", (e) => apiDatetimeToDate(e.created_at)),
} satisfies FieldsOf<AdminMachineWithOs>;

// cspell:words creds
